// extracted by mini-css-extract-plugin
export default {"item":"numberRange_item__Yan-D"};